import {
  ByIdPayload,
  ChangeParamsByIdPayload,
  FailByIdPayload,
  ListReducerTypes,
  NormalizedList,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { ItemListParams } from '../models/item-list-params';

export const ItemLoadListActionTypes: ListReducerTypes = {
  request: uniqueActionType('[item] Load list'),
  requestFail: uniqueActionType('[item] Load list fail'),
  requestSuccess: uniqueActionType('[item] Load list success'),
  requestClear: uniqueActionType('[item] Load list clear'),
  changeParams: uniqueActionType('[item] Load list change params'),
  clearParams: uniqueActionType('[item] Load list clear params'),
  clearIds: uniqueActionType('[item] Load list clear ids')
};

export class ItemLoadListAction implements PayloadAction {
  readonly type = ItemLoadListActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class ItemLoadListFailAction implements PayloadAction {
  readonly type = ItemLoadListActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ItemLoadListSuccessAction implements PayloadAction {
  readonly type = ItemLoadListActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedList>) {
  }
}

export class ItemLoadListClearAction implements PayloadAction {
  readonly type = ItemLoadListActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class ItemLoadListChangeParamsAction implements PayloadAction {
  readonly type = ItemLoadListActionTypes.changeParams;

  constructor(public payload: ChangeParamsByIdPayload<ItemListParams>) {
  }
}

export class ItemLoadListClearParamsAction implements PayloadAction {
  readonly type = ItemLoadListActionTypes.clearParams;

  constructor(public payload: ByIdPayload) {
  }
}


export class ItemLoadListClearIdsAction implements PayloadAction {
  readonly type = ItemLoadListActionTypes.clearIds;

  constructor(public payload: ByIdPayload) {
  }
}
